import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "nativewind/jsx-runtime";
import React from 'react';
import useNavigation from '@/navigation/useNavigation';
import ImageFileUtils from '@/utils/ImageFileUtils';
import CameraIcon from '@/assets/icon/ic_camera2.svg';
import CircleCloseIcon from '@/assets/icon/ic_circle_close.svg';
import * as S from './PhotosV2.style';
export default function PhotosV2({ value, maxPhotos, target, onChange }) {
    const navigation = useNavigation();
    const takePhoto = () => {
        navigation.navigate('Camera', {
            takenPhotos: value,
            onPhotosTaken: onChange,
            target,
        });
    };
    const deletePhoto = (photo) => {
        const newPhotos = value.filter(p => p.uri !== photo.uri);
        onChange(newPhotos);
    };
    const viewPhoto = (index) => {
        const imageUrls = value.map(p => ImageFileUtils.filepathFromImageFile(p));
        navigation.navigate('ImageZoomViewer', {
            imageUrls,
            index,
        });
    };
    const hasPhotos = value.length > 0;
    return (_jsxs(S.Photos, { children: [value.length < maxPhotos && (_jsx(S.Photo, { children: _jsxs(S.SmallCameraButton, { elementName: "photo_small_camera_button", onPress: takePhoto, children: [_jsx(CameraIcon, { width: 36, height: 36 }), _jsx(S.SmallCameraButtonText, { children: "\uC0AC\uC9C4 \uCD2C\uC601\uD558\uAE30" })] }) })), value.slice(0, 3).map((photo, index) => (_jsxs(S.Photo, { children: [_jsx(S.ThumbnailButton, { elementName: "photo_thumbnail", onPress: () => viewPhoto(index), children: _jsx(S.Thumbnail, { children: _jsx(S.ThumbnailImage, { source: { uri: ImageFileUtils.filepathFromImageFile(photo) } }) }) }), _jsx(S.DeleteButton, { elementName: "photo_delete_button", onPress: () => deletePhoto(photo), children: _jsx(CircleCloseIcon, { width: 24, height: 24 }) })] }, photo.uri))), !hasPhotos && (_jsxs(_Fragment, { children: [_jsx(S.Photo, {}), _jsx(S.Photo, {})] })), value.length === 1 && _jsx(S.Photo, {})] }));
}
